// import { Skeleton } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import ReactLoading from 'react-loading';

// function LoadingImg({ handleNavigateToProduct, product, handleContextMenu }) {
//   const [loaded, setLoaded] = useState(false);
//   const [noImgFound, setNoImgFound] = useState(false)

//   useEffect(() => {
//     const img = new Image();
//     img.src = product.image || "./images/No_Image.png";
//     img.onload = () => {
//       setLoaded(true);
//     };

//     setTimeout(() => {
//         setLoaded(true);
//     }, 1000);
//   }, [product.image]);

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100%",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {!loaded ? (
//         <div style={{margin:'0 auto', }} className=" h-100 w-100 d-flex justify-content-center align-items-center"  >
//         <ReactLoading type={'spokes'} color="#000" height={50} width={50}  />

//         </div>
//       ) : (
//         <img
//           src={product.image || "./images/noimage.jpg"}
//           onError={(e) => {
//             e.target.onerror = null;
//             e.target.src = "/images/No_Image.png";
//             setNoImgFound(true);
//           }}
//           alt={product.item_name}
//           onClick={handleNavigateToProduct}
//           onContextMenu={handleContextMenu}
//           style={{
//             width: "90%",
//             height: "90%",
//             objectFit: "cover",
//             display: "block",
//             opacity: noImgFound ? 0.3 : 1,
//             // border:'1px solid blue',
//             margin: '0 auto'
//           }}
//         />
//       )}
//     </div>
//   );
// }

// export default LoadingImg;


// import Img from 'react-cool-img';

// export default function LoadingImg( handleNavigateToProduct, product, handleContextMenu) {
//   return (
//     <>
//     <Img 
//       src={product.image}
//       placeholder={"./images/noimage.jpg"}
//       error="./images/noimage.jpg"
//       cache={true}
//       debounce={0}
//       retry={{ count: 3, delay: 2, accumulate: 'multiply' }}
//       observerOptions={{ threshold: 0.1 }}
//       onLoad={(e) => console.log('Image loaded')}
//     />
//     {/* <img src={product.image} alt='img' /> */}

//     </>
//   );
// }

import Img from 'react-cool-img';
import { useState, useEffect } from 'react';

export default function LoadingImg({ handleNavigateToProduct, product, handleContextMenu }) {
  const [imgSrc, setImgSrc] = useState(product.image || './images/noimage.jpg' );

  const handleError = () => {
    console.log("Failed to load image:", imgSrc);
    setImgSrc("./images/noimage.jpg");
  };

  return (
    

      <Img
        src={imgSrc}
        placeholder={"./images/img-loader.svg"}
        error="./images/noimage.jpg"
        cache={true}
        debounce={0}
        retry={{ count: 1, delay: 1 }}
        

        onError={handleError}
        style={{
          width: '100%',
          height: '100%',
          // border: '1px solid #ccc',
          // borderRadius: "10px", 
        }}
        onClick={handleNavigateToProduct}
        onContextMenu={handleContextMenu}
        
      />
     
  );
}